<template>
  <PopupTemplate @close="closeCuponAmigoDisponible()">
    <div>
      <div class="cabecera">¡Enhorabuena!</div>
      <p class="cuponAmigoDisponible"></p>
      <p>
        Ya tienes disponible tu 10% de descuento en la próxima renovación de tu
        póliza
      </p>
      <p>¡Acepta tu descuento!</p>
      <p v-if="portfolio.lstPolizasVehForCupones.length === 0 && portfolio.lstPolizasHogarForCupones.length === 0 && portfolio.lstPolizasMovilidadForCupones.length === 0"
        class="noHayPolizasDisponibles">
        No hay pólizas disponibles en este momento para poder asignar. Todas sus pólizas tienen 3 cupones asignados.
      </p>
      <template v-else>
        <p>Selecciona la póliza en la que quieres que lo apliquemos:</p>
        <PolizaAsignableCuponAmigo v-for="item in portfolio.lstPolizasVehForCupones" :key="item.idPoliza"
          :icono="iconoVeh(item)" :titulo="item.marca + ' ' + item.modelo" :subtitulo="item.matricula"
          @click="gotoPolizaVeh(item.idPoliza)" />

        <PolizaAsignableCuponAmigo v-for="item in portfolio.lstPolizasHogarForCupones" :key="item.idPoliza"
          :icono="iconoHogar(item)" :titulo="item.direccionCorta" :subtitulo="item.codPostal + ' ' + item.provincia"
          @click="gotoPolizaHogar(item.idPoliza)" />

        <PolizaAsignableCuponAmigo v-for="item in portfolio.lstPolizasMovilidadForCupones" :key="item.idPoliza"
          :icono="iconoMovilidad(item)" :titulo="item.tipoVehDesc" :subtitulo="item.marca + ' ' + item.modelo"
          @click="gotoPolizaMov(item.idPoliza)" />
      </template>
    </div>
  </PopupTemplate>
</template>

<script>
import IconoMoto from "@/assets/icono_moto.png";
import IconoVeh from "@/assets/icono_auto.png";
import IconoHogar from "@/assets/icono_hogar.png";
import IconoMovilidad from "@/assets/icono_movilidad.png";

/* eslint-disable no-console */
export default {
  computed: {
    portfolio() {
      return this.$store.state.portfolio;
    }
  },

  props: {
    cuponInic: { type: Object, required: true, default: null }
  },

  data() {
    return {
      cupon: this.cuponInic,
      polSeleccionada: null,
      mensajeBoton: "Aceptar"
    };
  },

  created() {
    console.log(this.cuponInic);
  },

  methods: {
    closeCuponAmigoDisponible() {
      this.$emit("closeInfoCuponAmigo");
    },

    gotoPolizaVeh: async function (idPoliza) {
      this.mensajeBoton = "Aplicar 10% en mi póliza: " + idPoliza;
      await this.$store.dispatch("asignaPolizaCuponAmigo", {
        cupon: this.cupon.cupon,
        idCupon: this.cupon.idCupon,
        idPoliza: idPoliza
      });
      this.$store.dispatch("getPortfolio");
      this.$emit("closeInfoCuponAmigo");
    },
    gotoPolizaHogar: async function (idPoliza) {
      this.mensajeBoton = "Aplicar 10% en mi póliza: " + idPoliza;
      await this.$store.dispatch("asignaPolizaCuponAmigo", {
        cupon: this.cupon.cupon,
        idCupon: this.cupon.idCupon,
        idPoliza: idPoliza
      });
      this.$store.dispatch("getPortfolio");
      this.$emit("closeInfoCuponAmigo");
    },
    gotoPolizaMov: async function (idPoliza) {
      this.mensajeBoton = "Aplicar 10% en mi póliza: " + idPoliza;
      await this.$store.dispatch("asignaPolizaCuponAmigo", {
        cupon: this.cupon.cupon,
        idCupon: this.cupon.idCupon,
        idPoliza: idPoliza
      });
      this.$store.dispatch("getPortfolio");
      this.$emit("closeInfoCuponAmigo");
    },

    iconoVeh(item) {
      return item.tipoAutomovil == "MOTO" ? IconoMoto : IconoVeh;
    },
    iconoHogar() {
      return IconoHogar;
    },
    iconoMovilidad() {
      return IconoMovilidad;
    }
  }
};
</script>

<style lang="scss">
.cuponAmigoDisponible {
  width: 15rem;
}

.cabecera {
  font-size: 120%;
  margin-bottom: 1rem;
  color: $colorMMT;
  width: 15rem;
  border-bottom: 2px solid $azulOscuroMMT;
}

.noHayPolizasDisponibles {
  color: tomato;
  font-weight: bold;
}
</style>
